export default "__VITE_ASSET__CDVw_1jD__"